/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory, Link } from 'react-router-dom';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import { DCDColDataForAll } from './gridComponent/TableHead';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  dispatchDisputedClaimsDetailObj,
  getStrengthDecr,
  callSearchClaimAPI,
  getDisputedClaimDetailsGrid,
  getExistingCorrLinkIds,
  saveDisputedClaimsForReview,
  dispatchFullScrrenClaimsDetail,
  dispatchSaveCancelClaimsDetail,
  dispatchdisputedClaimsDetail,
  saveDisputedClaimsForReviewError,
  saveDisputedClaimsForReviewResponse,
} from '../store/actions';
import { navigateToProvider } from '../../../Display/Claim/store/action';

import {
  closeTab,
  getCommonDropdownList,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { setCurrentNDCDetailsSelected } from '../../../Display/NDC/store/action';
import { navToClaimsDetail } from './ConstantData';
import CheckBoxRenderForDisputeClaim from './gridComponent/CheckBoxRenderForDisputeClaim';
import {
  dispatchProvideDetails,
  getProviderIdTypeDetails,
} from '../../../Display/Provider/store/action';
import {
  getClaimTableInfo,
  setDisplayClaimSearchScreenObj,
  setSelectedClaim,
  setSelectedClaimMode,
} from '../../../Display/Claim/store/action';
import {
  getClaimDetails,
  getNdcDetailsCall,
} from '../../../Research/ClaimAudits/store/actions';
import {
  FETCHALLPROVIDERLIST,
  getNdcMainGridDetail,
  getProvider,
  getProviderReviewClaimHeader,
} from '../../ProviderReview/Store/actions';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

const DisputedClaimsDetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const disputedCliamsDetailData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.setDisputedClaimsDetail?.claimData
  );
  const disputedCliamsDetailDataSuccess = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.setDisputedClaimsDetail?.response?.data?.message
  );
  const screenData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.disputedClaimsDetailsObj
  );
  const getStrengthState = useSelector(
    (state) => state?.sharedState?.PerformDisputeResolutionReducer?.getStrength
  );
  const getClaimHeaderData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.setClaimsHeader
  );
  const claimDetailFullScrren = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.claimDetailFullScrren
  );
  const saveCancelClaimsDetail = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.saveCancelClaimsDetail
  );
  const savelClaimsDetailResponse = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.saveClaimDetailResponse.data
  );
  const savelClaimsDetailErr = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.saveClaimDetailError
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [linkTableName, setLinkTableName] = React.useState('CLAIM');
  const [gridParams, setGridParams] = React.useState(null);
  const [tableData, setTableData] = React.useState();
  const [showComments, setShowComments] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(true);
  const [commonDropdownList, setCommonDropdownList] = React.useState({});
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [providerSelInt, setProviderSelInt] = React.useState('');
  const [errorMessages, setErrorMessages] = React.useState([]);

  const [state, setState] = React.useState(
    screenData?.state
      ? screenData?.state
      : {
          columnDisplay: 'F',
          invoiced: 1,
          nonInvoiced: 0,
          strength: '',
        }
  );
  const [hoverCCSec, setHoverCCSec] = React.useState(false);

  // dispatch function
  const setDisputedClaimData = (value) => {
    dispatch(dispatchDisputedClaimsDetailObj(value));
  };
  // fullscreen functionality
  const handleFullScreenView = () => {
    setSuccessMessage([]);
    setFullScreenView(!fullScreenView);
    dispatch(dispatchFullScrrenClaimsDetail(fullScreenView));
  };
  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridParams(params);
  };
  //  get quarter value useEffect
  React.useEffect(() => {
    if (_.isEmpty(getStrengthState)) {
      dispatch(
        getStrengthDecr({
          drugSeqNum: getClaimHeaderData?.payloadClaimsDetails?.drugSeqNum,
        })
      );
    }
  }, []);
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['PROVIDER_ID_TYPE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);

  // call after check all validation
  const onSubmit = (value) => {
    setClickOncloseTabBtn(value);
    openSave(value);
  };

  // save popup
  const openSave = (value) => {
    if (!value) {
      clickHandlerOnSave();
    } else {
      setOpen(value);
      setOpenCancel(false);
    }
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // save popup
  const handleOpenClose = () => {
    setOpenCancel(true);
  };
  // cancel popup
  const handleCancelClose = () => {
    setOpenCancel(false);
  };

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    if (data && data.length > 0) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: data.map((item) => {
          return item.corrLinkId;
        }),
      });
      const tempObj = data.map((item) => {
        if (
          result &&
          result.data?.length > 0 &&
          result.data.filter((x) => {
            return x === item.corrLinkId;
          }).length > 0
        ) {
          item.ccCommentsExist = 1;
        } else {
          item.ccCommentsExist = 0;
        }
        return item;
      });
      //update the tableData First
      // setTimeout(() => setTableData(tempObj), 1000);
      setTableData(tempObj);
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
      // eslint-disable-next-line no-unused-expressions
      //Then Refresh Grid cells if needed
    } else {
      setTableData([]);
    }
  };

  React.useEffect(() => {
    dispatch(saveDisputedClaimsForReviewResponse({}));
    if (
      disputedCliamsDetailData &&
      disputedCliamsDetailData.length > 0 &&
      disputedCliamsDetailDataSuccess == 'SUCESS'
    ) {
      setDisputedClaimData(getClaimHeaderData?.payloadClaimsDetails);
      handleExistingCommentList(disputedCliamsDetailData);
    } else {
      handleExistingCommentList([]);
    }
  }, [disputedCliamsDetailData, commentsList]);

  // handle after call service show success and error message
  React.useEffect(() => {
    const localErr = savelClaimsDetailErr || [];
    if (
      savelClaimsDetailResponse &&
      savelClaimsDetailResponse.message === 'SUCESS'
    ) {
      handleScrollToEvent();
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      dispatch(dispatchSaveCancelClaimsDetail(true));
      handleCancelClose();
      const payloadReset = getClaimHeaderData?.payloadClaimsDetails;
      dispatch(getDisputedClaimDetailsGrid(payloadReset));
      if (!clickOncloseTabBtn) {
        setSuccessMessage([]);
        saveDisputedClaimsForReviewResponse({});
        closeTab(navToClaimsDetail, history);
      }
      // setTimeout(() => {
      //   setSuccessMessage([]);
      // }, 3000);
    } else if (
      savelClaimsDetailResponse &&
      savelClaimsDetailResponse.message === 'failed'
    ) {
      handleScrollToEvent();
      const localErr = savelClaimsDetailErr || [];
      localErr.push({
        field: 'APIFailed',
        errorType: 'APIFailed',
        message: constantMessageData.FAILED_MESSAGE_GENERIC,
      });
      setSuccessMessage([]);
      dispatch(dispatchSaveCancelClaimsDetail(true));
    }
    saveDisputedClaimsForReviewResponse({});
    const unique = [...new Set(localErr)];
    dispatch(saveDisputedClaimsForReviewError(unique));
  }, [savelClaimsDetailResponse]);

  // for disable save cancel update
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      disputedCliamsDetailData &&
      Object.keys(disputedCliamsDetailData).length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === navToClaimsDetail && !saveCancelClaimsDetail) {
            item.isFormDirty = true;
            dispatch(dispatchSaveCancelClaimsDetail(false));
          } else if (item.navTo === navToClaimsDetail) item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!saveCancelClaimsDetail || disputedCliamsDetailData]);

  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.navTo === navToClaimsDetail && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === navToClaimsDetail && item.isFormSave) {
          item.isFormSave = false;
          clickHandlerOnSave();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      closeTab(navToClaimsDetail, history);
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // on change event on field
  const handleOnChangeEvent = (value, name) => {
     setSuccessMessage([]);
    dispatch(dispatchdisputedClaimsDetail([]));
    const payloadClaimsData = getClaimHeaderData?.payloadClaimsDetails;
    if (name === 'invoiced') {
      if (payloadClaimsData.displayNonInvoiced === '1') {
        setState({
          ...state,
          [name]: value,
          nonInvoiced: (state.nonInvoiced = 1),
        });
        setDisputedClaimData({
          state: { ...state, [name]: value },
        });
        payloadClaimsData.displayInvoiced = value ? 1 : 0;
        payloadClaimsData.displayNonInvoiced = 1;
        dispatch(getDisputedClaimDetailsGrid(payloadClaimsData));
      } else {
        setState({
          ...state,
          [name]: value,
          invoiced: (state.invoiced = value ? 1 : 0),
          nonInvoiced: (state.nonInvoiced = 1),
        });
        setDisputedClaimData({
          state: { ...state, [name]: value },
        });
        payloadClaimsData.displayInvoiced = value ? 1 : 0;
        payloadClaimsData.displayNonInvoiced = 1;
        dispatch(getDisputedClaimDetailsGrid(payloadClaimsData));
      }
      setTableData(disputedCliamsDetailData);
    } else if (name === 'nonInvoiced') {
      if (payloadClaimsData.displayInvoiced === '1') {
        setState({
          ...state,
          [name]: value,
          invoiced: (state.invoiced = 1),
        });
        setDisputedClaimData({
          state: { ...state, [name]: value },
        });
        payloadClaimsData.displayNonInvoiced = value ? 1 : 0;
        payloadClaimsData.displayInvoiced = 1;
        dispatch(getDisputedClaimDetailsGrid(payloadClaimsData));
      } else {
        setState({
          ...state,
          [name]: value,
          nonInvoiced: (state.nonInvoiced = value ? 1 : 0),
          invoiced: (state.invoiced = 1),
        });
        setDisputedClaimData({
          state: { ...state, [name]: value },
        });
        payloadClaimsData.displayNonInvoiced = value ? 1 : 0;
        payloadClaimsData.displayInvoiced = 1;
        dispatch(getDisputedClaimDetailsGrid(payloadClaimsData));
      }
      setTableData(disputedCliamsDetailData);
    }
    if (name === 'columnDisplay') {
      setState({ ...state, [name]: value });
      setDisputedClaimData({
        state: { ...state, [name]: value },
      });
      dispatch(getDisputedClaimDetailsGrid(payloadClaimsData));
      setTableData(disputedCliamsDetailData);
    }
  };
  const clickHandlerOnSave = () => {
    const payloadSave = Array.isArray(tableData)
      ? tableData.map((item) => {
          const data = {
            claimReviewId: {
              claimId: item.claimId,
              claimLineNum: item.claimLineNum,
            },
            providerId: item.providerId,
            providerReviewSeqNum: item.providerReviewSeqNum,
            drugSeqNum: getClaimHeaderData?.payloadClaimsDetails?.drugSeqNum,
            problemCd: item.problemCd,
            correctionCd: item.correctionCd || null,
            qtr: getClaimHeaderData?.quarter,
            lastUpdateDt: item.lastUpdateDt || null,
            lastUpdateUserId: item.lastUpdateUserId || null,
            selectForReview: item.ccSelectReview,
            providerIdTypeCd: item.providerIdTypeCd,
            reviewComplete: item.ccSelectReview ? 0 : 1,
          };
          return data;
        })
      : null;
    const result = dispatch(saveDisputedClaimsForReview(payloadSave));
    setOpen(false);
  };
    const onSelectionChanged =()=>{
    setSuccessMessage([]);
  }

  // Clear selected samples
  const clearSelectedSamples = () => {
    if (
      tableData?.filter((x) => {
        return x.ccSelectReview === 1;
      })?.length > 0
    ) {
      let tempObj = [];
      tempObj = tableData?.map((item) => {
        item.ccSelectReview = 0;
        return item;
      });
      setTableData([]);
      setTableData(tempObj);
      if (gridParams?.api) {
        gridParams.api.refreshCells();
      }
      dispatch(dispatchSaveCancelClaimsDetail(false));
    }
  };
  // reset All fields after click cancel button
  const resetAllFields = () => {
    handleCancelClose();
    const payloadReset = getClaimHeaderData?.payloadClaimsDetails;
    dispatch(getDisputedClaimDetailsGrid(payloadReset));
    dispatch(dispatchSaveCancelClaimsDetail(true));
  };

  // Modify units Redirection API Call
  // handing Claims page redirect
  const handleViewDetailsForUnits = async (data, searchScreenReduxObj) => {
     setSuccessMessage([]);
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: getClaimHeaderData.rebateProgramCd,
      searchByNdc: true,
      drugSqnNum: [getClaimHeaderData?.payloadClaimsDetails?.drugSeqNum],
      paidQtr: getClaimHeaderData?.quarter,
    });
    if (resultData && resultData?.data?.length > 0) {
      dispatch(setSelectedClaimMode('maintain'));
      dispatch(getClaimTableInfo(true));
      dispatch(setSelectedClaim(resultData?.data));
      dispatch(
        setDisplayClaimSearchScreenObj({
          ...searchScreenReduxObj,
          isibwdndc: false,
          isibwdclaim: true,
        })
      );
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    }
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // Go to Claims redirection API call
  const handleViewDetailsForClaims = async (data, key) => {
    dispatch(
      getClaimDetails({
        claimId: data.claimId,
        claimLineNum: data.claimLineNum,
        eventInquryKeyVO: [
          {
            keyType: 'Claim ID',
            key: `${data?.claimId}-${data?.claimLineNum}`,
          },
        ],
        functionCode: 'Claim',
        userID: logInUser.toUpperCase(),
      })
    );
    redirectURLLink(
      `/claimDetails/${data.claimId}`,
      `Claim Details [${data.claimId}]`,
      history,
      dispatch
    );
  };

  // Go to NDC redirection API Call
  const getNdcData = async (cellInfo) => {
    const response = await getNdcDetailsCall([
      {
        ndc: getClaimHeaderData?.ndc,
        drugName: getClaimHeaderData?.drugName,
      },
    ]);
    if (response.message === 'SUCESS') {
      dispatch(setCurrentNDCDetailsSelected(response?.data[0]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };
  const redirectToProviderReview = async (cellInfo) => {
    const payLoadForProvider = {
      providerId: cellInfo?.providerId,
      providerIdTypeCd: cellInfo?.providerIdType,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payLoadForProvider, () => {
        redirectURLLink(
          '/ProviderDetails',
          'Provider Details',
          history,
          dispatch
        );
      })
    );
  };
  // Go to Provider Review

  const handleOnSubmit = () => {
    if (!(parseFloat(providerSelInt) > 0)) {
      setErrorMessages([constantMessageData.GREATER_THAN_ZERO]);
    } else if (providerSelInt !== '') {
      if (tableData?.length > 0) {
        let tempObj = [];
        if (parseFloat(providerSelInt) === 1) {
          tempObj = tableData?.map((item) => {
            item.ccSelectReview = 1;
            return item;
          });
          setTableData([]);
          setTableData(tempObj);
          if (gridParams?.api) {
            gridParams.api.refreshCells();
          }
          setErrorMessages([]);
          setWarningAlert(false);
          dispatch(dispatchSaveCancelClaimsDetail(false));
        } else if (
          parseFloat(providerSelInt) > 1 &&
          parseFloat(providerSelInt) <= tableData?.length - 1
        ) {
          const num = parseFloat(providerSelInt);
          let multipleByNum = 0;
          let rowIndex = 1;
          tempObj = tableData?.map((item, index) => {
            if (parseFloat(multipleByNum) === parseFloat(index)) {
              item.ccSelectReview = 1;
              multipleByNum = rowIndex * num;
              rowIndex += 1;
            }
            return item;
          });
          setTableData([]);
          setTableData(tempObj);
          setErrorMessages([]);
          setWarningAlert(false);
          dispatch(dispatchSaveCancelClaimsDetail(false));
          if (gridParams?.api) {
            gridParams.api.refreshCells();
          }
        }
      }
    }
  };

  return (
    <div
      className=' tabs-container tBillPanel custom-check'
      data-testid='request-current-dispute-display'
    >
      <CustomSeparator parent1='Tasks' parent2='Disputed Claims Detail' />
      <Spinner load={spinnerLoader} />
      <DisplaySuccessMessages successMessages={successMessages} />
      <SaveCancelPopup
        open={open}
        data-testid='savePopup'
        title='Save'
        onConfim={() => {
          clickHandlerOnSave();
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid='cancelPopup'
        title='Cancel'
        onConfim={() => {
          resetAllFields();
        }}
        onCancel={() => {
          handleCancelClose();
        }}
      />
      {!claimDetailFullScrren && (
        <div className='row form-wrapper'>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='manufacturer-id-textField'
              id='manufacturer-id'
              label='Manufacturer ID'
              fullWidth
              disabled
              placeholder=''
              value={getClaimHeaderData?.mfgID}
              inputProps={{ maxLength: 38, id: 'manufacturer-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='NDC-textField'
              id='NDC-id'
              label='NDC'
              fullWidth
              disabled
              placeholder=''
              value={getClaimHeaderData?.ndc}
              inputProps={{ maxLength: 38, id: 'NDC-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='quarter-iD-textField'
              id='quarter-id'
              label='Quarter'
              fullWidth
              disabled
              placeholder=''
              value={getClaimHeaderData?.quarter}
              inputProps={{ maxLength: 38, id: 'quarter-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            {getClaimHeaderData?.mfgName &&
            getClaimHeaderData?.mfgName !== '' &&
            getClaimHeaderData?.mfgName.length > 25 ? (
              <OverlayTrigger
                placement='bottom'
                overlay={
                  <Tooltip id='labeler-tooltip'>
                    {getClaimHeaderData?.mfgName}
                  </Tooltip>
                }
              >
                <TextField
                  data-testid='manufacturer-name-tool-textField'
                  id='manufacturer-name-id-tooltip'
                  label='Manufacturer Name'
                  fullWidth
                  disabled
                  placeholder=''
                  value={`${getClaimHeaderData?.mfgName.substring(0, 25)}...`}
                  inputProps={{ maxLength: 38, id: 'Name-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </OverlayTrigger>
            ) : (
              <TextField
                data-testid='manufacturer-name-textField'
                id='manufacturer-name-id'
                label='Manufacturer Name'
                fullWidth
                disabled
                placeholder=''
                value={getClaimHeaderData?.mfgName}
                inputProps={{ maxLength: 38, id: 'Name-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='drug-name-textField'
              id='drug-name-id'
              label='Drug Name '
              fullWidth
              disabled
              placeholder=''
              value={getClaimHeaderData?.drugName}
              inputProps={{ maxLength: 38, id: 'drug-name-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='rebate-program-textField'
              id='rebate-program-id'
              label='Rebate Program'
              fullWidth
              disabled
              placeholder=''
              value={getClaimHeaderData?.rebateProgramCd}
              inputProps={{ maxLength: 38, id: 'rebate-program-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className='col-12 col-sm-12 col-md-4 input-md mui-custom-form'>
            <TextField
              data-testid='strength-id-textField'
              id='strength-id'
              label='Strength'
              fullWidth
              disabled
              placeholder=''
              value={getStrengthState?.strengthDescr}
              inputProps={{ maxLength: 38, id: 'strength-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
      )}
      {!claimDetailFullScrren && (
        <div className='row'>
          <div className='col-12 col-md-6'>
            <RadioGroupComponent
              data-testid='radio-button-for-column-display'
              id='radio-button-for-column-display_id'
              labelName='Column Display'
              required
              optionList={[
                { name: 'Financial', value: 'F' },
                { name: 'Patient', value: 'P' },
                { name: 'Prescription', value: 'Pre' },
                { name: 'All', value: 'A' },
              ]}
              defaultValue={state && state.columnDisplay}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'columnDisplay');
              }}
              className='log-batch-filter-radio frr-checkInvoiceRadio mandatory'
            />
          </div>
          <div className='col-12 col-md-6 mt-2 mt-md-0'>
            <fieldset className='custom-fieldset w-100  px-4 d-flex align-items-center '>
              <legend>Claims To Display</legend>
              <FormControlLabel
                className='ml-0'
                data-testid='checked_ia'
                control={<Checkbox color='primary' className='mr-2' />}
                label='Invoiced'
                value={state?.invoiced}
                checked={state?.invoiced}
                onChange={(e) => {
                  handleOnChangeEvent(e.target.checked, 'invoiced');
                }}
              />
              <FormControlLabel
                className='ml-0'
                data-testid='checked_ia_nonInvoiced'
                control={<Checkbox color='primary' className='mr-2' />}
                label='Non-Invoiced'
                value={state?.nonInvoiced}
                checked={state?.nonInvoiced}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked, 'nonInvoiced')
                }
              />
            </fieldset>
          </div>
        </div>
      )}
      {!claimDetailFullScrren && (
        <div className='row d-flex flex-row-reverse m-3'>
          <div className='btn-wrapper'>
            <Button
              className='btn btn-success btn-save'
              data-testid='rcdd-process-button_save'
              onClick={() => {
                onSubmit(true);
              }}
              disabled={saveCancelClaimsDetail}
            >
              <SVGComponent iconName='Icon-awesome-save' />
              &nbsp;Save
            </Button>
            <Button
              className='btn btn-cancel'
              data-testid='rcdd-process-button_cancel'
              onClick={() => handleOpenClose()}
              disabled={saveCancelClaimsDetail}
            >
              <SVGComponent iconName='Icon-cancel' />
              &nbsp;Cancel
            </Button>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
          <TableGridWithFeatures
            data-testid='drug-Activity-grid'
            rowSelection='single'
            onSelectionChanged={onSelectionChanged}
            rowMultiSelectWithClick={false}
            fullScreenView={claimDetailFullScrren}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={claimDetailFullScrren ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName='Claims Grid'
            handleOptionForDisputedClaims={(name) => {
              if (name === 'selectSample') {
                setWarningAlert(true);
                setProviderSelInt('');
              } else if (name === 'clearSelectedItem') {
                clearSelectedSamples();
              }
            }}
            rowData={tableData?.map((item, index) => {
              const firstDropdownVal =
                commonDropdownList?.PROVIDER_ID_TYPE_CD?.filter((x) => {
                  return (
                    x.codeValueID &&
                    x.codeValueID?.codeValue === item.providerIdTypeCd
                  );
                });
              if (firstDropdownVal && firstDropdownVal.length > 0) {
                item.providerIdType = firstDropdownVal[0].shortDescription;
              }
              item.index = index + 1;
              return item;
            })}
            columnDefs={DCDColDataForAll.filter((x) => {
              if (state.columnDisplay === 'F') {
                return (
                  x.field !== 'claimId' &&
                  x.field !== 'claimLineNum' &&
                  x.field !== 'claimCategoryCd' &&
                  x.field !== 'patientId' &&
                  x.field !== 'firstName' &&
                  x.field !== 'patientAge' &&
                  x.field !== 'patientGenderCd' &&
                  x.field !== 'prescriptionNum' &&
                  x.field !== 'serviceDt' &&
                  x.field !== 'dawInd' &&
                  x.field !== 'suppliedDays' &&
                  x.field !== 'numOfRefills'
                );
              }
              if (state.columnDisplay === 'P') {
                return (
                  x.field !== 'prescriptionNum' &&
                  x.field !== 'serviceDt' &&
                  x.field !== 'dawInd' &&
                  x.field !== 'suppliedDays' &&
                  x.field !== 'numOfRefills' &&
                  x.field !== 'submittedAmt' &&
                  x.field !== 'allowedAmt' &&
                  x.field !== 'tplAmt' &&
                  x.field !== 'copayAmt'
                );
              }
              if (state.columnDisplay === 'Pre') {
                return (
                  x.field !== 'claimId' &&
                  x.field !== 'claimLineNum' &&
                  x.field !== 'claimCategoryCd' &&
                  x.field !== 'patientId' &&
                  x.field !== 'firstName' &&
                  x.field !== 'patientAge' &&
                  x.field !== 'patientGenderCd' &&
                  x.field !== 'submittedAmt' &&
                  x.field !== 'allowedAmt' &&
                  x.field !== 'tplAmt' &&
                  x.field !== 'copayAmt'
                );
              }
              return x;
            })}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                const searchScreenReduxObj = useSelector(
                  (state) => state.sharedState.claim?.searchScreenReduxObj
                );
                return (
                  <div className='tdCell icon-btn-group'>
                    {hoverCCSec ? (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          type='button'
                          data-testid='comment-modal'
                          onClick={() => {
                            setCorrLinkId(
                              cellInfo && cellInfo?.data.corrLinkId
                            );
                            setLinkTableName('CLAIM');
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('CLAIM');
                              setShowComments(true);
                            }
                          }}
                          onMouseOver={() => {
                            setHoverCCSec(true);
                          }}
                          onMouseOut={() => {
                            setHoverCCSec(false);
                          }}
                          className='th-ic comment-ic frr-enabled-comment-btn'
                          variant='text'
                        >
                          {parseInt(cellInfo?.data.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt='comment' src={CommentVisibleIcon} />
                          ) : (
                            <img alt='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        type='button'
                        data-testid='comment-modal-btn'
                        onClick={() => {
                          setCorrLinkId(cellInfo && cellInfo?.data.corrLinkId);
                          setLinkTableName('CLAIM');
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('CLAIM');
                            setShowComments(true);
                          }
                        }}
                        onMouseOver={() => {
                          setHoverCCSec(true);
                        }}
                        onMouseOut={() => {
                          setHoverCCSec(false);
                        }}
                        className='th-ic comment-ic frr-enabled-comment-btn'
                        variant='text'
                      >
                        {parseInt(cellInfo?.data.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img alt='comment' src={CommentVisibleIcon} />
                        ) : (
                          <img alt='comment' src={CommentIcon} />
                        )}
                      </Button>
                    )}
                    <Dropdown className='icon-dropdown-container float-right'>
                      <Dropdown.Toggle className='icon-dropdown'>
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='action-tooltip'>Action</Tooltip>
                          }
                        >
                          <SVGComponent iconName='Icon-export1' />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className='export_dropdown h-auto'>
                        <Dropdown.Item
                          role='button'
                          onClick={() =>
                            handleViewDetailsForUnits(
                              cellInfo?.data,
                              searchScreenReduxObj
                            )
                          }
                        >
                          {' '}
                          Modify Units
                        </Dropdown.Item>

                        <Dropdown.Item
                          role='button'
                          onClick={() =>
                            handleViewDetailsForClaims(cellInfo?.data)
                          }
                        >
                          {' '}
                          Go to Claim
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() => getNdcData(cellInfo?.data)}
                        >
                          {' '}
                          Go to NDC
                        </Dropdown.Item>
                        <Dropdown.Item
                          role='button'
                          onClick={() =>
                            redirectToProviderReview(cellInfo?.data)
                          }
                        >
                          {' '}
                          Go to Provider Review
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              CheckBoxCellRender: CheckBoxRenderForDisputeClaim,
              PatientNameRenderer: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  `${`${cellInfo?.data.firstName} ${cellInfo?.data.middleInitial} ${cellInfo?.data.lastName}`}`
                    .length > 20
                ) {
                  return (
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='com-tooltip'>
                          {`${cellInfo?.data.firstName} ${cellInfo?.data.middleInitial} ${cellInfo?.data.lastName}`}
                        </Tooltip>
                      }
                    >
                      <div>
                        {`${`${cellInfo?.data.firstName} ${
                          cellInfo?.data.middleInitial
                        } ${cellInfo?.data.lastName.substring(0, 20)}`}...`}
                      </div>
                    </OverlayTrigger>
                  );
                }
                return (
                  <div>{`${cellInfo?.data.firstName} ${cellInfo?.data.middleInitial} ${cellInfo?.data.lastName}`}</div>
                );
              },
              ReimbursementAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.reimbursementAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ isTextColorRed: true }}
                      >{`(${cellInfo?.data?.reimbursementAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.reimbursementAmt}`}</div>
                    )}
                  </>
                );
              },
              SubmittedAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.submittedAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: 'red' }}
                      >{`(${cellInfo?.data?.submittedAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.submittedAmt}`}</div>
                    )}
                  </>
                );
              },
              AllowedAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.allowedAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: 'red' }}
                      >{`(${cellInfo?.data?.allowedAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.allowedAmt}`}</div>
                    )}
                  </>
                );
              },
              tplCellRenderer: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.tplAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: 'red' }}>{`(${cellInfo?.data?.tplAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.tplAmt}`}</div>
                    )}
                  </>
                );
              },
              copayCellRenderer: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.copayAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: 'red' }}
                      >{`(${cellInfo?.data?.copayAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.copayAmt}`}</div>
                    )}
                  </>
                );
              },
              ProviderIdRender: (cellInfo) => {
                return (
                  <Link
                    to='#'
                    role='button'
                    onClick={() => {
                      redirectToProviderReview(cellInfo?.data);
                    }}
                  >
                    {cellInfo && cellInfo.data.providerId}
                  </Link>
                );
              },
            }}
          />
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
      <CommonModal
        className='dialog-420'
        data-testid='common-modal-warning'
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          handleOnSubmit();
        }}
        onClose={() => {
          setWarningAlert(false);
          setProviderSelInt('');
        }}
        okTitle='Ok'
        modalTitle='Provide Selection Interval'
        childrenComponent={
          <>
            {errorMessages?.length > 0 && (
              <DisplayErrorMessages errorMessages={[errorMessages]} />
            )}
            <div className='p-3'>
              <b>
                Please enter a value that specifies how many rows to advance
                prior to checking the Select for Review column. For example, to
                select every row, enter 1. To select every other row, enter 2.
              </b>
            </div>
            <div className='mui-custom-form mandate-fields  input-md '>
              <TextField
                id='providerSelInt'
                label=''
                fullWidth
                placeholder=''
                InputLabelProps={{ shrink: true }}
                value={providerSelInt}
                type='number'
                onChange={(e) => {
                  if (parseFloat(e.target.value) >= 0) {
                    setProviderSelInt(e.target.value);
                  } else if (e.target.value === '') {
                    setProviderSelInt('');
                  }
                }}
                helperText={
                  errorMessages?.length > 0
                    ? constantMessageData.GREATER_THAN_ZERO
                    : null
                }
                error={
                  errorMessages?.length > 0
                    ? constantMessageData.GREATER_THAN_ZERO
                    : null
                }
              />
            </div>
          </>
        }
      />
    </div>
  );
};
export default DisputedClaimsDetail;
